export default function(role, options) {
    return ACL.checkRole(role) ? options.fn(this) : options.inverse(this);
}
